/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useState } from 'react';
import ClientTable from '@/components/tables/ClientTable';
import { Box, Button, useTheme } from '@mui/material';
import { PageHeader } from '@/components/layouts/PageHeader';
import { PageTabsBar } from '@/components/layouts/PageHeader/PageTabsBar';
import { getPipelineIcon } from '@/utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { Add } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import { openDialog } from '@/features/dialog/dialogSlice';
import { TeamViewToggle } from '@/components/buttons/TeamViewToggle';
import { KanbanToggle } from '@/components/buttons/KanbanToggle';
import { VIEW_TYPES } from '@/features/config/helper';
import PreviewDrawer from '@/components/Drawers/PreviewDrawer';
import { KanbanView } from '@/components/views/KanbanView';

export const ProspectsPage = () => {
	const theme = useTheme();
	const dispatch = useDispatch();

	const prospectPipelineId = process.env.REACT_APP_PIPELINE_PROSPECTS;

	// Shared with New Business / other deal pipelines
	const { kanbanView } = useSelector((state) => state.userPrefs);
	const [searchParams, setSearchParams] = useSearchParams();
	const currentTab = searchParams.get('tab') || 'active';

	const tabs = [
		{
			label: 'Prospects',
			value: 'active',
		},
		{
			label: 'Closed',
			value: 'closed',
		},
	];

	const handleTabChange = (event, value) => {
		setSearchParams((prev) => {
			const newParams = new URLSearchParams(prev);
			newParams.set('tab', value);
			return newParams;
		});
	};

	const handleNewClient = () => {
		dispatch(
			openDialog({
				dialogName: 'clientDialog',
				data: { isProspect: true, type: VIEW_TYPES.create },
			}),
		);
	};

	const createButton = (
		<Button variant='contained' startIcon={<Add />} onClick={handleNewClient}>
			New Prospect
		</Button>
	);

	const showKanban = kanbanView && currentTab !== 'closed';

	return (
		<>
			<Box pt={1}>
				<PageHeader
					title={'Prospects'}
					icon={getPipelineIcon(
						'Prospects',
						'40px',
						theme.palette.mode === 'dark' ? { bgColor: 'transparent' } : undefined,
					)}
				/>
				<PageTabsBar
					tabs={showKanban ? [] : tabs}
					value={currentTab}
					onChange={handleTabChange}
					queryParam='tab'
					actions={
						<>
							{currentTab !== 'closed' && <KanbanToggle />}
							{createButton}
						</>
					}
				/>

				{showKanban ? (
					<KanbanView pipelineId={prospectPipelineId} objectType='prospect' />
				) : (
					<Box px={3}>
						<ClientTable tab={currentTab} />
					</Box>
				)}
			</Box>
			<PreviewDrawer />
		</>
	);
};
